export const apiSuccess = (code: any) => {
  return 200 <= parseInt(code) && parseInt(code) <= 300;
};
